import { createRoute } from '@tanstack/react-router';
import { ChannelsPage } from '@/features/growth/Channels';
import { Route as shellRoute } from '../_shell';

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/growth/channels',
  component: ChannelsPage,
});
